// Dev-token API for the in-app Management suite (management-badge app users only)
import axios from "axios";
import appApi, { API } from "./appApi";

const devApi = axios.create({ baseURL: `${API}/api` });

let refreshing = null;

async function refreshDevToken() {
  if (!refreshing) {
    refreshing = appApi
      .post("/app/dev-session")
      .then((r) => {
        localStorage.setItem("cfm_dev_token", r.data.access_token);
        return r.data.access_token;
      })
      .finally(() => { refreshing = null; });
  }
  return refreshing;
}

devApi.interceptors.request.use(async (config) => {
  let tok = localStorage.getItem("cfm_dev_token");
  if (!tok) tok = await refreshDevToken();
  config.headers.Authorization = `Bearer ${tok}`;
  return config;
});

devApi.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (err.response?.status === 401 && !err.config._retried) {
      err.config._retried = true;
      localStorage.removeItem("cfm_dev_token");
      return devApi(err.config);
    }
    throw err;
  }
);

export default devApi;
